import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["align", "autoAlign", "feedback", "feedbackTimeout", "iconDescription", "className", "onClick"];
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cx from 'classnames';
import { Copy as Copy$1 } from '@carbon/icons-react';
import Copy from '../Copy/Copy.js';
import { LayoutConstraint } from '../Layout/index.js';
import { usePrefix } from '../../internal/usePrefix.js';
import { noopFn } from '../../internal/noopFn.js';
import deprecateValuesWithin from '../../prop-types/deprecateValuesWithin.js';
import { mapPopoverAlign } from '../../tools/mapPopoverAlign.js';
function CopyButton(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'bottom' : _ref$align,
    _ref$autoAlign = _ref.autoAlign,
    autoAlign = _ref$autoAlign === void 0 ? false : _ref$autoAlign,
    _ref$feedback = _ref.feedback,
    feedback = _ref$feedback === void 0 ? 'Copied!' : _ref$feedback,
    _ref$feedbackTimeout = _ref.feedbackTimeout,
    feedbackTimeout = _ref$feedbackTimeout === void 0 ? 2000 : _ref$feedbackTimeout,
    _ref$iconDescription = _ref.iconDescription,
    iconDescription = _ref$iconDescription === void 0 ? 'Copy to clipboard' : _ref$iconDescription,
    className = _ref.className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noopFn : _ref$onClick,
    other = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  return /*#__PURE__*/React.createElement(LayoutConstraint, {
    size: {
      default: 'md',
      max: 'lg'
    }
  }, /*#__PURE__*/React.createElement(Copy, _extends({
    feedback: feedback,
    feedbackTimeout: feedbackTimeout,
    onClick: onClick,
    align: align,
    autoAlign: autoAlign,
    className: cx(className, "".concat(prefix, "--copy-btn")),
    "aria-label": iconDescription
  }, other), /*#__PURE__*/React.createElement(Copy$1, {
    className: "".concat(prefix, "--snippet__icon")
  })));
}
export { CopyButton as default };